<template>
  <div class="fSize">
    <!--<van-search v-model="listQuery.phoneNumber" show-action placeholder="请输入搜索关键词:手机号" @search="searchFun">
        <template #action>
            <div @click="searchFun">搜索</div>
        </template>
    </van-search>-->
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" :finished-text="finishedText" :error.sync="error"
                :error-text="errorText" @load="searchFun">
        <!--<van-cell class="newCell font28" style="padding-right:0.72rem;">
            <van-row>
                <van-col span="8">编号</van-col>
                <van-col span="5">姓名</van-col>
                <van-col span="11">体检时间</van-col>
            </van-row>
        </van-cell>-->
        <van-cell v-for="item in list" :key="item.ywlsh" is-link class="newCell font28">
          <van-row @click="goDetail(item)">
            <van-col span="8">{{ item.ywlsh }}</van-col>
            <van-col span="5">{{ item.xm }}</van-col>
            <van-col span="11">{{ item.zjrq }}</van-col>
          </van-row>
        </van-cell>
      </van-list>
    </van-pull-refresh>
    <!--去用户绑定页面-->
    <van-action-sheet safe-area-inset-bottom :round="false" v-model="show" title="体检用户绑定"
                      :close-on-click-overlay="false" @click-overlay="tipsFun">
      <UserAdd @fatherMethod="closeFun"></UserAdd>
    </van-action-sheet>
  </div>
</template>
<script>
import {Search, PullRefresh, List, Cell, Col, Row, ActionSheet, Toast} from 'vant';
import {getReportList} from '@/api/report';
import UserAdd from '@/components/UserAdd';

export default {
  components: {
    [Search.name]: Search,
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [Cell.name]: Cell,
    [Row.name]: Row,
    [Col.name]: Col,
    [ActionSheet.name]: ActionSheet,
    UserAdd
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      finishedText: "没有更多了",
      error: false,
      errorText: null,
      refreshing: false,
      listQuery: {
        page: 1,
        limit: 15,
        phoneNumber: undefined
      },
      //------
      show: false
    }
  },
  created() {
    const that = this;
    //---控制头尾显示与隐藏----
    //that.$emit('footer', true);
  },
  mounted() {
    var _this = this;
    window.history.pushState(null, null, "#");
    window.addEventListener(
        "popstate",
        _this.closePage,
        false
    );
    console.info(document.title);
  },
  methods: {

    closePage() {
      WeixinJSBridge.call("closeWindow");
    },
    //搜索
    searchFun() {
      const that = this;
      that.error = false;
      //清空列表数据
      that.list = [];
      that.listQuery.page = 1;
      that.getList();
    },
    //重置基础数据
    resetCon() {
      const that = this;
      that.list = [];
      that.finished = false;
      that.error = false;
      that.errorText = null;
      that.listQuery.page = 1;
      that.listQuery.limit = 15;
    },
    //列表请求
    getList() {
      const that = this;
      if (sessionStorage.getItem("userIsBang") !== 'yes') {
        //如果用户信息为空则去设置用户
        that.show = true;
        return false;
      }
      // 将 loading 设置为 true，表示处于加载状态
      that.loading = true;
      let data = JSON.parse(JSON.stringify(that.listQuery));
      data.openId = sessionStorage.getItem("openid");
      getReportList(data).then(resp => {
        this.loading = false;
        if (resp.code === 200) {
          that.listQuery.page = that.listQuery.page + 1;
          let newArray = resp.data ? resp.data : [];
          that.list.push.apply(that.list, newArray);
        } else {
          that.error = true;
          that.errorText = resp.msg + ",点击重试";
        }
        if (that.list.length >= resp.count) {
          that.finished = true;
        }
      }).catch(err => {
        console.log(err);
      })
    },
    //下拉刷新
    onRefresh() {
      const that = this;
      //清空列表数据
      that.resetCon();
      //重新加载数据
      that.getList();
    },
    //去详情页面
    goDetail(e) {
      const that = this;
      window.removeEventListener(
          "popstate",
          that.closePage
      );
      that.$router.push({path: "/reportDetail", query: {reportDetail: JSON.stringify(e)}});
    },
    //关闭添加框组件
    closeFun() {
      const that = this;
      that.show = false;
      //刷新列表数据
      that.searchFun();
    },
    //判断是否绑定
    tipsFun() {
      if (sessionStorage.getItem("userIsBang") !== 'yes') {
        Toast("请先绑定用户信息...")
      }
    }
  }
}
</script>
<style scoped lang="scss">
.newCell {
  padding: 0.4rem 0.32rem;
}
</style>
